import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { get_blog_details } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { Link } from "react-router-dom";
import BlogDetailContent from "../../../components/BlogDetailContent";

export default function BlogDetails({isLoader}) {

    const [data, setData] = useState([])
    const navigate = useNavigate()
    const location = useLocation();
    const BlogId = location.state && location.state.BlogId;

    const getBlogData = () => {
        isLoader(true)
        get_blog_details({ blog_id: BlogId }).then((resposnse) => {
            if (resposnse.code == 1) {
                setData(resposnse.data)
                isLoader(false)
            }else{
                setData([])
                isLoader(false)
            }
        });
    }

    useEffect(() => {
        getBlogData()
    }, [BlogId])
    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-none d-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a href="#!" className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="#" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <div className="class-content w-100 px-5 mt-4">
                    <div >
                        {/*start*/}
                        <span className="mb-4 arrow_left mb-3 d-block" onClick={handleBack} style={{ cursor: 'pointer' }}>
                            <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" />
                            </svg>
                            <span className="ms-2">Back</span>
                        </span>
                        {/*end*/}
                        {/*start*/}
                        {data.blog_details && <BlogDetailContent blog={{ ...data.blog_details, blog_media: data.blog_media }} />}
                        {/*end*/}
                    </div>
                </div>
            </div>
        </main>
    </>
}